export const environment = {
  production: false,
  // endpoint: 'http://localhost:3000/dev/nec/api',
  // endpoint: 'http://57.183.14.138/api',
  endpoint: 'https://ticket-sales-dashboard.yuumi.click/show-sales',
  CRYPTO_SECRET_KEY: '729bd12b3d1257b665fbacaa586f8184',
  CRYPTO_IV: '1a010075980b52faf9ae79b22f3d38c8',
};
